import React, { useState, useEffect } from 'react'
import 'style.css';
import 'css/care_window.css';
import 'css/responsive.css';
import 'css/perfect-scrollbar.css';
import 'css/custom.css';
import 'css/color_2.css';
import 'css/bootstrap-select.css';

import carewindow_blue from 'images/carewindow_blue.png'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { checkLoginStatus, loginUser } from 'js/Api/index';
import { Button } from '../Component/CommonFormEle';


function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [rememberMe, setRememberMe] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const navigate = useNavigate()
    const location = useLocation();

    useEffect(() => {
        const verifyLoginStatus = async () => {
            const loggedin = localStorage.getItem('isLoggedIn') === 'true';
            if (loggedin) {
                const result = await checkLoginStatus();

                if (result.success && result?.data?.portalUserDTO !== null && result?.data?.portalUserDTO !== undefined) {
                    localStorage.setItem('userInfo', JSON.stringify(result.data.portalUserDTO));

                    const { role, organizationGuid } = result.data.portalUserDTO;
                    const isStaff = role === 'staff';
                    const isManager = role === 'manager';
                    const isSuperAdmin = role === 'SuperAdmin'
                    const isAdmin = role === 'Admin'

                    if ((isStaff || isManager) && organizationGuid) {
                        navigate(`/userboard/${organizationGuid}`)
                    } else if (isSuperAdmin || isAdmin) {
                        navigate('/organise')
                    }
                } else {
                    // 登录会话已过期，清除本地存储
                    localStorage.removeItem('isLoggedIn');
                    localStorage.removeItem('rememberMe');
                    localStorage.removeItem('userInfo');
                }
            }
        }

        verifyLoginStatus()
    }, [navigate])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const result = await loginUser(email, password, rememberMe);

        if (result.success) {
            localStorage.setItem('isLoggedIn', 'true');
            localStorage.setItem('userInfo', JSON.stringify(result.data));

            if (rememberMe) {
                localStorage.setItem('rememberMe', 'true');
            } else {
                localStorage.removeItem('rememberMe');
            }

            const searchParams = new URLSearchParams(location.search);
            const redirectUrl = searchParams.get('redirect');

            if (redirectUrl) {
                window.location.href = redirectUrl;
            } else {
                const { role, organizationGuid } = result.data;


                if ((role === 'staff' || role === 'manager') && organizationGuid) {
                    navigate(`/userboard/${organizationGuid}`);
                } else if (role === 'SuperAdmin' || role === 'Admin') {
                    navigate('/organise');
                }
            }
        } else {
            setError(result.error);
        }

        setIsLoading(false);
    }

    return (
        <div className="full_container">
            <div className="container">
                <div className="center verticle_center full_height">
                    <div className="login_section" style={{ maxWidth: "640px" }}>
                        <div className="logo_login">
                            <div className="center">
                                {/* <img className="login-logo" src={logo} alt="Logo" /> */}
                                <img className="login-carewindow" width="500" src={carewindow_blue} alt="CareWindow" />
                            </div>
                        </div>
                        <div className="login_form">
                            {/* <t className="user-info-text">Please enter your user information.</t> */}
                            <form id="loginForm" onSubmit={handleSubmit}>
                                <fieldset>
                                    <div className="field">
                                        <label className="label_field">Email Address </label>
                                        <input type="email" id="email" placeholder="E-mail" required value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="field">
                                        <label className="label_field">Password  </label>
                                        <input type="password" id="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                                    </div>
                                    <div className="field">
                                        <label className="label_field hidden">hidden label</label>
                                        <label className="form-check-label">
                                            <input className="form-check-input" type="checkbox" name="remember" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />  Remember Me</label>
                                        <Link className="forgot" to="/send_email">Forgot Password?</Link>
                                    </div>
                                    <div className="field margin_0">
                                        <label className="label_field hidden">hidden label</label>
                                        <Button onClick={handleSubmit} variant="blue" disabled={isLoading}>
                                            Sign in
                                        </Button>
                                    </div>
                                </fieldset>
                            </form>
                            {error && (
                                <div className="error-message" style={{ fontWeight: '700px', color: 'red', marginTop: '10px', textAlign: 'center', marginLeft: '60px' }}>
                                    {error}
                                </div>
                            )}
                            {isLoading && <div>Loading...</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login